import styled, { css } from 'styled-components';

type ContentProps = {
  hasBorder: boolean;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 20rem;
  height: 100%;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  max-width: 20rem;
  align-items: flex-end;
  height: 100%;

  input {
    display: flex;
    width: 100%;
    max-width: 20rem;
    border: 0;
    height: 2.313rem;
    font-size: 20px;
    background: transparent;
    font-family: 'Futura PT';
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text};
    outline: none;
  }
  .MuiIconButton-root {
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    max-width: 2.5rem;
    min-height: 2.5rem;
    min-width: 2.5rem;
    align-items: center;
    justify-content: center;
  }
  .MuiInputBase-root-MuiInput-root:after {
    border-bottom: 2px solid red;
  }
  ${({ theme, hasBorder }) =>
    hasBorder &&
    css`
      border-bottom: 1px solid ${theme.colors.primary};
      margin-right: 0.5rem;
      input {
        max-width: 20rem;
      }
    `}
`;
